var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import moment from 'moment';
import { View } from 'react-native';
import { Placeholder } from './components';
import { Text } from '../Text';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { User } from '../User';
import { Focusable } from '../Focusable';
import { Checkbox } from '../Checkbox';
import { UserType } from '@gopeerproject/chuck';
export const Notification = (_a) => {
    var _b;
    var { style, fluid } = _a, props = __rest(_a, ["style", "fluid"]);
    const styles = useStyleSheet(getStyles);
    if (props.isLoading)
        return React.createElement(Placeholder, { fluid: fluid, style: style });
    const [type, name] = /^(tutor|student|parent|admin)/.test(props.payload.preview)
        ? props.payload.preview.split('-')
        : [];
    const image = type ? undefined : props.payload.preview;
    const isSeen = props.status !== 'delivered' || (props.isEditing && !props.isSelected);
    return (React.createElement(Focusable, Object.assign({ style: [styles.container, fluid ? styles.fluid : null, style], hoverStyle: props.isEditing ? {} : styles.hover, disabled: !!props.disabled || props.isEditing, onPress: props.isEditing ? props.onSelect : props.onPress }, (props.isEditing ? { disabledStyle: {} } : {})),
        props.isEditing && (React.createElement(Checkbox, { checked: !!props.isSelected, onChange: props.onSelect, style: styles.checkbox })),
        React.createElement(User, { size: 'lg', image: image, type: (_b = type) !== null && _b !== void 0 ? _b : UserType.STUDENT, name: name !== null && name !== void 0 ? name : 'GP' }),
        React.createElement(View, { style: styles.main },
            React.createElement(View, { style: styles.row },
                React.createElement(Text, { style: [styles.title, isSeen ? styles.titleSeen : {}], numberOfLines: 1, type: 'body', size: 'lg', weight: 'semibold', ellipsizeMode: 'tail' }, props.payload.title),
                props.status === 'delivered' && !props.isEditing && (React.createElement(View, { style: styles.dot }))),
            React.createElement(View, { style: [styles.row, styles.rowBottom] },
                React.createElement(Text, { style: [styles.body, isSeen ? styles.bodySeen : {}], numberOfLines: 1, type: 'body', size: 'md', weight: 'regular', ellipsizeMode: 'tail' }, props.payload.body),
                React.createElement(Text, { style: styles.time, type: 'body', size: 'md', weight: 'regular' }, moment(props.createdAt).format('h:mm A'))))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: size.G,
        borderRadius: size.G
    },
    fluid: { flex: 1 },
    hover: { backgroundColor: color.invert2.p10 },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    rowBottom: {
        marginTop: size.B
    },
    main: {
        flex: 1,
        justifyContent: 'space-between',
        marginLeft: size.G
    },
    title: {
        color: color.invert2.p100,
        flex: 1,
        marginRight: size.G
    },
    titleSeen: {
        color: color.invert2.p68
    },
    body: {
        flex: 1,
        color: color.invert2.p68,
        marginRight: size.G
    },
    bodySeen: {
        color: color.invert2.p56
    },
    time: {
        color: color.invert2.p42,
        flexShrink: 0
    },
    dot: {
        width: size.C,
        height: size.C,
        borderRadius: 9999,
        backgroundColor: color.primary.solid
    },
    checkbox: {
        marginRight: size.G
    }
}));
//# sourceMappingURL=index.js.map